<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="99.574" height="99.574">
    <g transform="translate(3.674 3.674)" stroke-miterlimit="10" stroke-width="6" fill="none">
      <circle cx="37.529" cy="37.529" r="37.529" transform="rotate(-90 46.113 37.529)" stroke="#c8cdda" />
      <circle
        ref="progressMeter"
        class="progressMeter"
        :class="{'noPercentage': percentage === 0}"
        cx="37.651" cy="37.651" r="37.651"
        transform="rotate(-90 46.113 37.529)"
        stroke="#00519d" stroke-linecap="round"
        stroke-dasharray="0 236" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      required: true,
    }
  },
  mounted() {
    this.calculateCircleLength();
    this.setPercentage();
  },
  data() {
    return {
      circleLengthInPixels: 0,
    }
  },
  watch: {
    percentage() {
      this.setPercentage();
    },
  },
  methods: {
    calculateCircleLength() {
      this.circleLengthInPixels = this.$refs.progressMeter.getTotalLength();
    },
    setPercentage() {
      const lengthPercentage = (this.percentage * this.circleLengthInPixels) / 100;
      this.$refs.progressMeter.style.strokeDasharray = `${lengthPercentage}, ${this.circleLengthInPixels}`;
    }
  }
}
</script>

<style lang="stylus" scoped>
.progressMeter
  transition stroke-dasharray 850ms
.noPercentage
  visibility hidden
</style>
